import { APISWRFallbackProvider } from '@dtx-company/inter-app/src/hooks/useAPISWR/useAPISWR'
import { Plan } from '@dtx-company/true-common/src/types/Plan'
import { ReactNode } from 'react'
import { getPlans } from '@dtx-company/inter-app/src/api/subscription-service/getPlans'

interface TrialsEnabledFallbackDataProviderProps {
  data: Plan[]
  children: ReactNode
}

export function TrialsEnabledFallbackDataProvider(
  props: TrialsEnabledFallbackDataProviderProps
): JSX.Element {
  return <APISWRFallbackProvider fetcher={getPlans} options={{}} {...props} />
}
